// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HFok","tabsBox":"styles_tabsBox__1aqfR","createButton":"styles_createButton__rTXgn"};